import classNames from "classnames";
import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { InfoLight } from "assets/icons";

export const ChatHeader = ({
  totalTime,
  timeLeft,
  children: SubmitChatButton,
  chatStarted,
  multiChatQuiz = false,
}) => {
  const fillPercent = (timeLeft / totalTime) * 100
  return (
    <>
      <div
        className={classNames(
          "hidden min-h-[80px] sticky top-0 flex items-center justify-between py-2.5 px-[15px] border-b-[1px] border-b-stone-300",
          "sm:static sm:justify-between sm:bg-opacity-0 sm:bg-none sm:px-[30px] sm:shadow-none sm:flex",
          {
            "hidden": !chatStarted,
            "sm:py-[20px]": !multiChatQuiz
          }
        )}
      >
        <div className="flex items-center">
          <CircularTimer
            fillPercent={fillPercent}
            heightClassName="h-[50px]"
          />
          <p className="font-semibold text-base text-white sm:text-bistre ml-2">
            {
              timeLeft === 0
                ? `0:00`
                : new Date(timeLeft * 1000).toISOString().substr(14, 5)
            }
          </p>
        </div>
        {SubmitChatButton}
      </div>
    </>
  );
};

export const MobileHeader = ({ chatStarted, endChatBtn, openMobileInstructions, totalTime, timeLeft }) => {
  const fillPercent = (timeLeft / totalTime) * 100

  return (
    <div
      className={classNames(
        "min-h-[50px] text-white fixed w-full top-[0px] flex items-center justify-between py-2 px-[15px] z-[19] backdrop-blur-lg",
        "sm:hidden",
        {
          "hidden": !chatStarted
        }
      )}
    >
      <div className="flex items-center">
        <CircularTimer
          fillPercent={fillPercent}
          heightClassName="h-[30px]"
        />
        <p className="font-semibold text-base text-white sm:text-bistre ml-2">
          {
            timeLeft === 0
              ? `0:00`
              : new Date(timeLeft * 1000).toISOString().substr(14, 5)
          }
        </p>
      </div>
      <div className="flex items-center">
        {endChatBtn}
        <span onClick={openMobileInstructions}>
          <InfoLight />
        </span>
      </div>
    </div>
  )
}

const CircularTimer = ({ fillPercent, heightClassName = "" }) => {
  return (
    <span className="rounded-full max-w-[36px] sm:max-w-[unset] border-[#FFF] border-solid border-2 p-[2px]">
      <CircularProgressbar
        value={fillPercent}
        strokeWidth={50}
        styles={buildStyles({
          strokeLinecap: "butt",
          trailColor: '#fff',
          pathColor: "#AC95CF"
        })}
        className={`${heightClassName}`}
      />
    </span>
  )
}